import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { EntityViewLayout } from "../entityLayout/entityViewLayout";
import { getAllGymReport } from "../../store/gyms/gymActions";

export const ShowGymsReports = () => {
  const gym = useSelector((state) => state.gym);
  const { isLodaing } = useSelector((state) => state.errors);
  const dispatch = useDispatch();

  const tableProps = {
    name: "Gym Report",
    routePath: "reports/gyms-admin",
    addNewText: "Add new gym report",
    isBreadcrumbs: true,
    isAddNew: false,
    isSearch: true,
    isFilters: true,
    isDateFilters: true,
    isTimeFilters: false,
    isPriceFilter: false,
    isCsvConvert: true,
    isExcelConvert: true,
    columns: [
      {
        Header: "Id",
        accessor: "id",
        maxWidth: 50,
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Gym Created",
        accessor: "createdAt",
      },
      {
        Header: "Mobile",
        accessor: "gym_mobile",
      },
    ],
  };

  const searchFields = [
    "name",
    "description",
    "email",
    "createdAt",
    "gym_mobile",
  ];
  let history = useHistory();

  const csvHeaders = [
    { label: "Id", key: "id" },
    { label: "Name", key: "name" },
    { label: "Description", key: "description" },
    { label: "Email", key: "email" },
    { label: "Gym Created", key: "createdAt" },
    { label: "Mobile", key: "gym_mobile" },
  ];

  const excelHeaders = [
    {
      label: "Id",
      fieldName: "id",
      valuePath: "id",
    },
    {
      label: "Name",
      fieldName: "name",
      valuePath: "name",
    },
    {
      label: "Description",
      fieldName: "description",
      valuePath: "description",
    },
    { label: "Email", fieldName: "email", valuePath: "email" },
    {
      label: "Gym Created",
      fieldName: "createdAt",
      valuePath: "createdAt",
    },
    {
      label: "Mobile",
      fieldName: "gym_mobile",
      valuePath: "gym_mobile",
    },
  ];

  const customFilter = ({ start_date, end_date }) => {
    dispatch(getAllGymReport(start_date, end_date));
  };

  const clearFilter = () => {
    dispatch(getAllGymReport());
  };

  useEffect(() => {
    dispatch(getAllGymReport());
  }, []);

  return (
    <EntityViewLayout
      isLoading={isLodaing}
      items={gym.gyms}
      searchFields={searchFields}
      tableProps={tableProps}
      history={history}
      customFilter={customFilter}
      csvHeaders={csvHeaders}
      excelHeaders={excelHeaders}
      clearFilter={clearFilter}
      csvFilePrefix="gym-report"
    />
  );
};
